// extracted by mini-css-extract-plugin
export default {"content":"wqRfV","navbarTitle":"TBZvQ"};